import React from "react";
import SelectComponent from "../general/SelectComponent";
import {
  difficultyMode,
  disabledKeyNumberQ,
  disabledKeyTypesQ,
  examMode,
  questionsPerExam,
  questionsPerExamFree,
  typeOfQuestions,
  typeOfQuestionsFree,
} from "../../data/examModes";
import { Link } from "react-router-dom";

const ExamModes = ({ register, errors, freeTrial, attempts }) => {
  return (
    <div className="flex flex-col gap-4 py-4">
   {freeTrial && (
  <>
    {attempts >= 1 ? (
      <div className="p-4 bg-themeBackground-0 border border-blue-300 rounded-lg  ">
        <p className="text-center font-medium text-[14px] text-themeSecondry-0">
          You have used {5 - attempts} out of 5 attempts from  your free trial.
          <br />
          To unlock unlimited attempts,{" "}
          <span>
            <a href="/subscriptions" className="text-blue-900 underline hover:text-blue-600 transition duration-200">
              Buy Subscription
            </a>
          </span>
        </p>
      </div>
    ) : (
      <div className="p-4 bg-red-50 border border-red-300 rounded-lg  ">
        <p className="text-center font-medium text-[14px] text-red-700">
          You have used all your free trial attempts.
          <br />
          To unlock unlimited attempts,{" "}
          <span>
            <a href="/subscriptions" className="text-red-900 underline hover:text-red-600 transition duration-200">
              Buy Subscription
            </a>
          </span>
        </p>
      </div>
    )}
  </>
)}


      <SelectComponent
        freeTrial={freeTrial}
        data={freeTrial ? typeOfQuestionsFree : typeOfQuestions}
        placeholder={"Select Type of Questions"}
        register={register}
        errors={errors}
        label={"Type Of Questions"}
        name="typeOfQuestions"
        disabledKeys={freeTrial ? disabledKeyTypesQ : null}
      />
      <SelectComponent
        data={examMode}
        register={register}
        placeholder={"Select Mode of Your Exam"}
        errors={errors}
        label={"Exam Mode"}
        name="examMode"
      />
      <SelectComponent
        data={difficultyMode}
        register={register}
        placeholder={"Select Difficulty Level"}
        errors={errors}
        label={"Difficulty Level"}
        name="difficultyMode"
      />
      <SelectComponent
        freeTrial={freeTrial}
        data={freeTrial ? questionsPerExamFree : questionsPerExam}
        register={register}
        placeholder={"Select Questions Per Exam"}
        errors={errors}
        label={"Questions Per Exam"}
        name="questionsPerExam"
        disabledKeys={freeTrial ? disabledKeyNumberQ : null}
      />
    </div>
  );
};

export default ExamModes;
